// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .ecl-table-container {
     width: 100%;
     min-height: 50px;
     overflow: auto;
     height: 100%;
     display: flex;
     flex-direction: column;
 }


 .ecl-table-cell {
     min-width: 200px;
     display: flex;
     align-items: center;
     justify-content: center;
     border-right: 1px dotted var(--table-body-border)
 }

 .table-row-hover:hover {
    border-top: var(--border);
    border-bottom: var(--border);
    background-color: var(--table-row-hover);
    cursor: pointer;
 }

 .ecl-table-cell:last-of-type {
     border-right: none;
 }

 .ecl-table-cell .string-cell {
     width: 100%;
     max-height: 100%;
     margin: 0;
     padding: var(--padding-sm);
 }

 /* Let normal cell wrapping occur, scrollbar vertical*/
 .ecl-table-cell .cell-wrapped {
     overflow-y: auto;
 }

 /*Truncate with ellipsis overflow, no wrap.*/
 .ecl-table-cell .cell-trunc,
 .ecl-table-cell .string-trunc {
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
 }

 .ecl-table-cell input {
     margin: 0;
 }

 .ecl-table-cell .checkbox-contain {
     background-color: unset;
 }

.ecl-table-cell button {
    margin: 0;
}

.ecl-table-cell .ecl-select-new {
    margin: 0;
}

 .button-cell button {
     border-radius: 0;
     background-color: unset;
     width: 100%;
     height: 100%;
     color: var(--text);
     width: 45px;
     margin: 0
 }
 
 .button-cell button .themed-svg-container {
    max-height: 30px;
 }

 .ecl-table-cell .checkbox-option {
     height: 35px;
     width: 35px;
 }

 .ecl-table-cell .checkbox-option .ecl-checkbox {
     width: 35px;
     height: 35px;
 }

 .ecl-table-row {
     display: flex;
     padding-right: 5px;
 }

 .table-alt-row {
     background-color: var(--table-alt-row);
 }

 .table-alt-row {
     background-color: var(--table-alt-row);
 }

 .ecl-table-header-container {
     min-height: 40px;
     display: flex;
     width: 100%;
     background-color: unset;
     overflow: hidden;
 }

 .header-row {
     height: 100%;
     border-bottom: 1px solid var(--window-bg);
     background-color: var(--sub-window-bg);
     overflow: auto;
     scrollbar-width: none;
 }

 .header-row::-webkit-scrollbar {
     display: none;
 }

 .header-cell {
     font-weight: bold;
     background-color: var(--table-alt-row);
     display: flex;
     justify-content: space-between;
 }

 .header-cell .header-stacker {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
 }

 .header-cell .header-stacker p {
    border-top: var(--border);
 }

 .header-cell .header-stacker p:first-of-type {
    border: none;
 }

 

 .header-cell button, .table-select-container {
     background-color: unset !important;
     color: var(--text);
     width: 40px;
     text-align: left;
     margin: 0;
     display: flex;
     justify-content: center;
     align-items: center;
 }

 .table-filter-container {
    display: flex;
    flex-direction: column;
 }

 
 .table-select-container .select-custom-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
 }

 .table-filter-container .ecl-select-new .drop-down-trigger {
    padding: 0;
    margin: 0;
 }

 .header-cell .drop-down-container {
     width: 100%;
 }

 .header-cell .table-header-modal-trigger {
     padding: 0;
 }

 .sticky-row {
     display: flex
 }

 .ecl-table-body-container {
     height: calc(100% - 40px);
     min-height: calc(100% - 40px);
     width: 100%;
     overflow: hidden;
     display: flex;
 }

 .ecl-table-body {
     height: 100%;
     width: 100%;
     overflow: auto;
 }

 .ecl-table-body-sticky {
     height: 100%;
     overflow-y: auto;
     overflow-x: hidden;
 }

 .ecl-table-body-empty {
     width: 100%;
     display: flex;
     justify-content: center;
     align-items: center;
 }

 .ecl-table-body-empty p {
     font-weight: bold;
 }

 .sticky-col-left {
     scrollbar-width: none;
 }

 .sticky-col-left::-webkit-scrollbar {
     display: none;
 }

 .sticky-col-right::-webkit-scrollbar:horizontal {
     display: none
 }

 .sticky-col-right {
    overflow-x: hidden;
 }

 .nested-table-body::-webkit-scrollbar:vertical {
     display: none
 }

 .ecl-table-header-sticky-left .header-cell:first-of-type {
     border-radius: var(--border-radius) 0px 0px 0px;
 }

 .ecl-table-header-sticky-left .header-cell:last-of-type {
     border-right: 1px solid black;
 }

 .ecl-table-header-sticky-right .header-cell:first-of-type {
     border-left: 1px solid black;
 }

 .ecl-table-header-sticky-right .header-cell:last-of-type {
     border-radius: 0px var(--border-radius) 0px 0px;
 }

 .sticky-col-left {
     border-right: 1px solid black;
 }

 .sticky-col-right {
     border-left: 1px solid black;
 }`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLTable/ECLTable.css"],"names":[],"mappings":"CAAC;KACI,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,YAAY;KACZ,aAAa;KACb,sBAAsB;CAC1B;;;CAGA;KACI,gBAAgB;KAChB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB;CACJ;;CAEA;IACG,yBAAyB;IACzB,4BAA4B;IAC5B,wCAAwC;IACxC,eAAe;CAClB;;CAEA;KACI,kBAAkB;CACtB;;CAEA;KACI,WAAW;KACX,gBAAgB;KAChB,SAAS;KACT,0BAA0B;CAC9B;;CAEA,sDAAsD;CACtD;KACI,gBAAgB;CACpB;;CAEA,4CAA4C;CAC5C;;KAEI,gBAAgB;KAChB,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;KACI,SAAS;CACb;;CAEA;KACI,uBAAuB;CAC3B;;AAED;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;CAEC;KACI,gBAAgB;KAChB,uBAAuB;KACvB,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,WAAW;KACX;CACJ;;CAEA;IACG,gBAAgB;CACnB;;CAEA;KACI,YAAY;KACZ,WAAW;CACf;;CAEA;KACI,WAAW;KACX,YAAY;CAChB;;CAEA;KACI,aAAa;KACb,kBAAkB;CACtB;;CAEA;KACI,sCAAsC;CAC1C;;CAEA;KACI,sCAAsC;CAC1C;;CAEA;KACI,gBAAgB;KAChB,aAAa;KACb,WAAW;KACX,uBAAuB;KACvB,gBAAgB;CACpB;;CAEA;KACI,YAAY;KACZ,yCAAyC;KACzC,sCAAsC;KACtC,cAAc;KACd,qBAAqB;CACzB;;CAEA;KACI,aAAa;CACjB;;CAEA;KACI,iBAAiB;KACjB,sCAAsC;KACtC,aAAa;KACb,8BAA8B;CAClC;;CAEA;IACG,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;CACtB;;CAEA;IACG,yBAAyB;CAC5B;;CAEA;IACG,YAAY;CACf;;;;CAIA;KACI,kCAAkC;KAClC,kBAAkB;KAClB,WAAW;KACX,gBAAgB;KAChB,SAAS;KACT,aAAa;KACb,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;IACG,aAAa;IACb,sBAAsB;CACzB;;;CAGA;IACG,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB;;CAEA;IACG,UAAU;IACV,SAAS;CACZ;;CAEA;KACI,WAAW;CACf;;CAEA;KACI,UAAU;CACd;;CAEA;KACI;CACJ;;CAEA;KACI,yBAAyB;KACzB,6BAA6B;KAC7B,WAAW;KACX,gBAAgB;KAChB,aAAa;CACjB;;CAEA;KACI,YAAY;KACZ,WAAW;KACX,cAAc;CAClB;;CAEA;KACI,YAAY;KACZ,gBAAgB;KAChB,kBAAkB;CACtB;;CAEA;KACI,WAAW;KACX,aAAa;KACb,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;KACI,iBAAiB;CACrB;;CAEA;KACI,qBAAqB;CACzB;;CAEA;KACI,aAAa;CACjB;;CAEA;KACI;CACJ;;CAEA;IACG,kBAAkB;CACrB;;CAEA;KACI;CACJ;;CAEA;KACI,+CAA+C;CACnD;;CAEA;KACI,6BAA6B;CACjC;;CAEA;KACI,4BAA4B;CAChC;;CAEA;KACI,+CAA+C;CACnD;;CAEA;KACI,6BAA6B;CACjC;;CAEA;KACI,4BAA4B;CAChC","sourcesContent":[" .ecl-table-container {\r\n     width: 100%;\r\n     min-height: 50px;\r\n     overflow: auto;\r\n     height: 100%;\r\n     display: flex;\r\n     flex-direction: column;\r\n }\r\n\r\n\r\n .ecl-table-cell {\r\n     min-width: 200px;\r\n     display: flex;\r\n     align-items: center;\r\n     justify-content: center;\r\n     border-right: 1px dotted var(--table-body-border)\r\n }\r\n\r\n .table-row-hover:hover {\r\n    border-top: var(--border);\r\n    border-bottom: var(--border);\r\n    background-color: var(--table-row-hover);\r\n    cursor: pointer;\r\n }\r\n\r\n .ecl-table-cell:last-of-type {\r\n     border-right: none;\r\n }\r\n\r\n .ecl-table-cell .string-cell {\r\n     width: 100%;\r\n     max-height: 100%;\r\n     margin: 0;\r\n     padding: var(--padding-sm);\r\n }\r\n\r\n /* Let normal cell wrapping occur, scrollbar vertical*/\r\n .ecl-table-cell .cell-wrapped {\r\n     overflow-y: auto;\r\n }\r\n\r\n /*Truncate with ellipsis overflow, no wrap.*/\r\n .ecl-table-cell .cell-trunc,\r\n .ecl-table-cell .string-trunc {\r\n     overflow: hidden;\r\n     text-overflow: ellipsis;\r\n     white-space: nowrap;\r\n }\r\n\r\n .ecl-table-cell input {\r\n     margin: 0;\r\n }\r\n\r\n .ecl-table-cell .checkbox-contain {\r\n     background-color: unset;\r\n }\r\n\r\n.ecl-table-cell button {\r\n    margin: 0;\r\n}\r\n\r\n.ecl-table-cell .ecl-select-new {\r\n    margin: 0;\r\n}\r\n\r\n .button-cell button {\r\n     border-radius: 0;\r\n     background-color: unset;\r\n     width: 100%;\r\n     height: 100%;\r\n     color: var(--text);\r\n     width: 45px;\r\n     margin: 0\r\n }\r\n \r\n .button-cell button .themed-svg-container {\r\n    max-height: 30px;\r\n }\r\n\r\n .ecl-table-cell .checkbox-option {\r\n     height: 35px;\r\n     width: 35px;\r\n }\r\n\r\n .ecl-table-cell .checkbox-option .ecl-checkbox {\r\n     width: 35px;\r\n     height: 35px;\r\n }\r\n\r\n .ecl-table-row {\r\n     display: flex;\r\n     padding-right: 5px;\r\n }\r\n\r\n .table-alt-row {\r\n     background-color: var(--table-alt-row);\r\n }\r\n\r\n .table-alt-row {\r\n     background-color: var(--table-alt-row);\r\n }\r\n\r\n .ecl-table-header-container {\r\n     min-height: 40px;\r\n     display: flex;\r\n     width: 100%;\r\n     background-color: unset;\r\n     overflow: hidden;\r\n }\r\n\r\n .header-row {\r\n     height: 100%;\r\n     border-bottom: 1px solid var(--window-bg);\r\n     background-color: var(--sub-window-bg);\r\n     overflow: auto;\r\n     scrollbar-width: none;\r\n }\r\n\r\n .header-row::-webkit-scrollbar {\r\n     display: none;\r\n }\r\n\r\n .header-cell {\r\n     font-weight: bold;\r\n     background-color: var(--table-alt-row);\r\n     display: flex;\r\n     justify-content: space-between;\r\n }\r\n\r\n .header-cell .header-stacker {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n }\r\n\r\n .header-cell .header-stacker p {\r\n    border-top: var(--border);\r\n }\r\n\r\n .header-cell .header-stacker p:first-of-type {\r\n    border: none;\r\n }\r\n\r\n \r\n\r\n .header-cell button, .table-select-container {\r\n     background-color: unset !important;\r\n     color: var(--text);\r\n     width: 40px;\r\n     text-align: left;\r\n     margin: 0;\r\n     display: flex;\r\n     justify-content: center;\r\n     align-items: center;\r\n }\r\n\r\n .table-filter-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n }\r\n\r\n \r\n .table-select-container .select-custom-trigger {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n }\r\n\r\n .table-filter-container .ecl-select-new .drop-down-trigger {\r\n    padding: 0;\r\n    margin: 0;\r\n }\r\n\r\n .header-cell .drop-down-container {\r\n     width: 100%;\r\n }\r\n\r\n .header-cell .table-header-modal-trigger {\r\n     padding: 0;\r\n }\r\n\r\n .sticky-row {\r\n     display: flex\r\n }\r\n\r\n .ecl-table-body-container {\r\n     height: calc(100% - 40px);\r\n     min-height: calc(100% - 40px);\r\n     width: 100%;\r\n     overflow: hidden;\r\n     display: flex;\r\n }\r\n\r\n .ecl-table-body {\r\n     height: 100%;\r\n     width: 100%;\r\n     overflow: auto;\r\n }\r\n\r\n .ecl-table-body-sticky {\r\n     height: 100%;\r\n     overflow-y: auto;\r\n     overflow-x: hidden;\r\n }\r\n\r\n .ecl-table-body-empty {\r\n     width: 100%;\r\n     display: flex;\r\n     justify-content: center;\r\n     align-items: center;\r\n }\r\n\r\n .ecl-table-body-empty p {\r\n     font-weight: bold;\r\n }\r\n\r\n .sticky-col-left {\r\n     scrollbar-width: none;\r\n }\r\n\r\n .sticky-col-left::-webkit-scrollbar {\r\n     display: none;\r\n }\r\n\r\n .sticky-col-right::-webkit-scrollbar:horizontal {\r\n     display: none\r\n }\r\n\r\n .sticky-col-right {\r\n    overflow-x: hidden;\r\n }\r\n\r\n .nested-table-body::-webkit-scrollbar:vertical {\r\n     display: none\r\n }\r\n\r\n .ecl-table-header-sticky-left .header-cell:first-of-type {\r\n     border-radius: var(--border-radius) 0px 0px 0px;\r\n }\r\n\r\n .ecl-table-header-sticky-left .header-cell:last-of-type {\r\n     border-right: 1px solid black;\r\n }\r\n\r\n .ecl-table-header-sticky-right .header-cell:first-of-type {\r\n     border-left: 1px solid black;\r\n }\r\n\r\n .ecl-table-header-sticky-right .header-cell:last-of-type {\r\n     border-radius: 0px var(--border-radius) 0px 0px;\r\n }\r\n\r\n .sticky-col-left {\r\n     border-right: 1px solid black;\r\n }\r\n\r\n .sticky-col-right {\r\n     border-left: 1px solid black;\r\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
